export default __webpack_public_path__ + "static/media/070_boost.last.eafe4b7e.png";